import { AutosignLogo } from 'ui'

export const UnexpectedError = () => {
  return (
    <div className='h-screen flex items-center justify-center flex-col'>
      <AutosignLogo className='w-32 h-32' />
      <h1 className='text-center text-5xl font-bold'>
        500
        <br /> Algo salio mal
      </h1>
      <div className='text-center p-1 flex flex-col'>
        <p className='text-lg my-5 max-w-3xl'>
          El equipo de autosign ya fue notificado del error y lo solucionará lo
          antes posible. <br /> Disculpa por las molestias ocasionadas.
        </p>
      </div>
    </div>
  )
}
